export default __webpack_public_path__ + "e002cf1493ac7fbe89647c664296772e.svg";